export enum CustomerTypeValues {
  Household = "1",
  Company = "2",
  Tradesman = "4",
}

export const EnterpriseCustomerTypeValues = [CustomerTypeValues.Company, CustomerTypeValues.Tradesman];

export enum CompanyTypeValues {
  Tradesman = "tradesman",
  Company = "company",
}

export const DefaultCustomerType = "household";
